import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setActivityList } from '../../../actions/actions';
import { activityById } from '../../../services/activityService';
import ActivityItem from './ActivityItem';
import ActivityEmptyState from './ActivityEmptyState';
import { toast } from 'react-hot-toast';
import { Logger } from '../../../utils/logger';
import { Component } from 'lucide-react';

interface ActivityTabProps {
  leadId: string;
  totalActivities: number;
  onAddActivity: () => void;
  onEditActivity: (activityId: string, action: string) => void;
  className?: string;
}

interface Activity {
  _id: string;
  type: string;
  description: string;
  createdAt: string;
  // Add other activity properties as needed
}

const ActivityTab = React.memo<ActivityTabProps>(({
  leadId,
  totalActivities,
  onAddActivity,
  onEditActivity,
  className = ''
}) => {
  

  const dispatch = useDispatch();
  const activities = useSelector((state: any) => state.rootReducers?.activity?.activities || []);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Add this to both ActivityTab and ActivityItem components
const renderCount = useRef(0);



  const handleEditActivity = useCallback(async (name: string, id: string, action: string) => {
  
    
    try {
      const response = await activityById(id);
     
      if (response && response.status) {
        onEditActivity(id, action);
      }
    } catch (err) {
   
      toast.error('Error while fetching activity data');
    }
  }, [onEditActivity]);

  useEffect(() => {
  
  }, [activities]);

  if (error) {
  
    return <div className="alert alert-danger">{error}</div>;
  }

  return (
    <div className={`activity-tab ${className}`}>
      <div className="detail_activity_scroll">
        {isLoading ? (
          <div className="text-center py-4">Loading activities...</div>
        ) : activities.length > 0 ? (
          activities.map((activity: Activity, index: number) => {
          
            return (
              <ActivityItem
                key={activity._id}
                activity={activity}
                handleEditModal={handleEditActivity}
                name="activity"
              />
            );
          })
        ) : (
          <ActivityEmptyState
            type="activities"
            actionLabel="Add Activity"
            onAction={onAddActivity}
          />
        )}
      </div>
    </div>
  );
});

ActivityTab.displayName = 'ActivityTab';

export default ActivityTab;